module.exports = __webpack_public_path__ + "static/media/ic-dura-o.f7c59f01.svg";